import React from "react";
import styles from "./DynamicDialog.module.css";
import { CircularProgress } from "@mui/material";

interface FieldProps {
  label?: string;
  type?: string;
  placeholder?: string;
  value?: string | boolean | any;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

interface ButtonProps {
  label?: string;
  onClick?: any;
}

interface DynamicDialogProps {
  isOpen: boolean;
  onClose: any;
  title?: string;
  title2?: string;
  description?: string | any;
  Loader?: boolean;
  fields: FieldProps[];
  buttons: ButtonProps[];
}

const DynamicDialog: React.FC<DynamicDialogProps> = ({
  isOpen,
  onClose,
  title,
  title2,
  description,
  Loader,
  fields,
  buttons,
}) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const submitButton = buttons.find((btn) => btn.label === "Submit");

    if (submitButton && submitButton.onClick) {
      submitButton.onClick();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {title2 && <h6 className={styles.title2}>{title2}</h6>}
        {
          <ul className={styles.description}>
            {description && description?.map((desc: any) => <li>{desc}</li>)}
          </ul>
        }
        <form className={styles.form} onSubmit={handleSubmit}>
          {fields.map((field, index) => (
            <>
              {field.type !== "checkbox" && (
                <div key={index} className={styles.field}>
                  {field.label && (
                    <label className={styles.label}>{field.label}</label>
                  )}
                  <input
                    className={styles.input}
                    type={field.type || "text"}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    required={field.required}
                  />
                </div>
              )}
              {field.type === "checkbox" && (
                <div key={index} className={styles.checkboxfield}>
                  <input
                    className={styles.checkbox}
                    type={field.type || "text"}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    required={field.required}
                  />
                  {field.label && (
                    <label className={styles.checkbox_label}>
                      {field.label}
                    </label>
                  )}
                </div>
              )}
            </>
          ))}
          <div className={styles.buttonContainer}>
            {buttons.map((button, index) => {
              const actionButtons = [
                "Submit",
                "Delete",
                "Confirm",
                "Reactivate",
                "Resume",
              ];
              if (actionButtons.includes(button.label ? button.label : "")) {
                return (
                  <button
                    key={index}
                    type="submit"
                    className={`${styles.button} ${styles.submitButton}`}
                    onClick={button.onClick}
                  >
                    {!Loader ? (
                      button.label
                    ) : (
                      <CircularProgress size={25} style={{ color: "white" }} />
                    )}
                  </button>
                );
              } else {
                return (
                  <button
                    key={index}
                    type="button"
                    onClick={button.onClick}
                    className={`${styles.button} ${button.label === "Cancel" ? styles.cancelButton : ""}`}
                  >
                    {button.label}
                  </button>
                );
              }
            })}
          </div>
        </form>
      </div>
    </div>
  );
};

export default DynamicDialog;
